import React, { Component, PropTypes } from 'react';
import { hexToRgba, Units, Colors } from 'Css';
import classNames from 'classnames';
import DragSource from 'react-dnd/lib/DragSource';
import { pageModules } from 'Constants';
import * as Icons from 'components/Icons';
import { Styles, IconButton, FlatButton, Dialog } from 'material-ui';
import DialogPortal from 'components/DialogPortal';
const { Spacing } = Styles;
import { PageModuleActions, PageLayoutActions } from 'actions';

const css = oxygenCss({
  task: {
    textAlign: 'left',
  },
  root: {
    position: 'relative',
    textAlign: 'center',
    padding: '0px 10px',
    userSelect: 'none',
    lineHeight: `${Units.keyline}px`,
    backgroundColor: '#F0F0F0',
    height: Units.keyline,
    cursor: 'pointer',
    boxSizing: 'border-box',
    border: 'solid 2px transparent',
    ':hover': {
      backgroundColor: '#d7f6f7',
      border: `solid 2px ${Colors.creen}`,
      color: Colors.creen
    },
    '>SVG': {
      verticalAlign: 'middle'
    },
    '&isOver': {
      border: `solid 2px ${hexToRgba(Colors.creen, 20)} !important`,
      backgroundColor: `${hexToRgba(Colors.creen, 50)} !important`
    },
    '&isDragging': {
      opacity: 0.25,
      border: `solid 2px ${hexToRgba(Colors.creen, 10)} !important`,
      backgroundColor: `${hexToRgba(Colors.creen, 25)} !important`
    }
  },
  afterMarker: {
    position: 'absolute',
    right: `${-Units.base + 1}px`,
    top: `${-Units.base}px`,
    bottom: `${-Units.base}px`,
    borderStyle: 'none dashed none none',
    border: `dashed 1px ${hexToRgba(Colors.creen, 90)}`
  },
  beforeMarker: {
    position: 'absolute',
    left: `${-Units.base + 1}px`,
    top: `${-Units.base}px`,
    bottom: `${-Units.base}px`,
    borderStyle: 'none dashed none none',
    border: `dashed 1px ${hexToRgba(Colors.creen, 90)}`
  }
});

const styles = {
  icon: {
    width: Units.base * 4,
    height: Units.base * 4,
  },
  smallIcon: {
    width: Units.base * 2.5,
    height: Units.base * 2.5
  },
  deleteButton: {
    position: 'absolute',
    right: -10,
    lineHeight: `${Spacing.desktopKeylineIncrement -
      2 * Spacing.desktopGutterMini}px`,
    padding: Spacing.desktopGutterMini,
    top: -5
  }
};

const dragSource = {
  beginDrag(props) {
    return {
      pageModuleId: props.id,
      pageRowId: props.pageRowId,
      type: props.type
    };
  },
  endDrag(props, monitor) {
    props.endDrag(monitor.getItem(), monitor.didDrop());
  }
};

class PageLayoutOverviewColumn extends Component {
  static propTypes = {
    type: PropTypes.object,
    id: PropTypes.number,
    // react-dnd props
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    connectDragPreview: PropTypes.func,
    endDrag: PropTypes.func,
    isDragging: PropTypes.bool,
    isOver: PropTypes.bool,
    marked: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      controls: false
    };
  }

  toggleControls = () => {
    this.setState({ controls: !this.state.controls });
    PageLayoutActions.selectPageModule(this.props.id);
  };

  handleDelete = () => {
    this.refs.confirmDialog.show();
  };

  cancelDelete() {
    this.refs.confirmDialog.dismiss();
  }

  deleteModule() {
    PageModuleActions.deletePageModule(this.props.id);
  }

  render() {
    const { type, marked, isDragging, data } = this.props;
    let deleteButton, deleteDialog;
    const classes = classNames(css.root, {
      [css.task]: type.name === 'task',
      [css.isDragging]: isDragging,
      controls: this.state.controls
    });

    const standardActions = [
      <FlatButton
        key="cancel"
        label={this.context.getIntlMessage('No')}
        primary
        onTouchTap={::this.cancelDelete}
      />,
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('Yes')}
        secondary
        onTouchTap={::this.deleteModule}
      />
    ];

    let dialog = (
      <DialogPortal>
        <Dialog
          ref="confirmDialog"
          title={this.context.getIntlMessage('Remove')}
          actions={standardActions}
          dismissOnClickAway
          style={{ zIndex: 99 }}
        >
          {this.context.getIntlMessage('module.confirmDelete')}
        </Dialog>
      </DialogPortal>
    );

    if (this.state.controls) {
      deleteButton = (
        <div>
          <IconButton
            iconStyle={styles.smallIcon}
            style={Object.assign({}, styles.deleteButton)}
            onTouchTap={this.handleDelete}
          >
            <Icons.Delete color={'#B0281A'} />
          </IconButton>
        </div>
      );
    }
    let Icon;
    if(type.name === 'quiz') {
      Icon = Icons[pageModules['task'].icon]
    } else {
      Icon = Icons[pageModules[type.name].icon]
    }

    let name = null;
    if(type.name === 'task'){
      const caption = Array.isArray(data.params.task.caption.main) ? data.params.task.caption.main.join() : data.params.task.caption.main;
      if(data.params.task.caption.main && data.params.task.caption.main.length > 35) {
        name = <p style={{ display: 'inline'}}>{caption.substr(0, 40)}...</p>
      } else {
        name = <p style={{ display: 'inline'}}>{caption}</p>
      }
    }
    let content = (
      <div>
        <div className={classes} onTouchTap={this.toggleControls}>
          <Icon style={{  ...styles.icon, marginRight: type.name === 'task' && '12px'}} color={'#777777'} />
          {name}
          {marked === 'after' && <div className={css.afterMarker} />}
          {marked === 'before' && <div className={css.beforeMarker} />}
          {deleteButton}
          {dialog}
        </div>
      </div>
    );

    // Connect as drag source
    content = this.props.connectDragSource(content, { dropEffect: 'move' });
    // Connect to drag layer
    content = this.props.connectDragPreview(content);

    return content;
  }
}

export default DragSource('CourseColumn', dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}))(PageLayoutOverviewColumn);



// WEBPACK FOOTER //
// ./src/js/components/Page/LayoutOverview/PageLayoutOverviewColumn.js